import React from 'react';
import MUIClickAwayListener, {
  ClickAwayListenerProps as MUIClickAwayListenerProps,
} from '@material-ui/core/ClickAwayListener';

interface ClickAwayListenerProps extends MUIClickAwayListenerProps {}

const ClickAwayListener = (props: ClickAwayListenerProps) => {
  /**
   * ClickAwayListener props always passing `style` property and it will cause error,
   * so we need to remove `it from props.
   */
  const {
    children,
    onClickAway,
    disableReactTree,
    mouseEvent,
    touchEvent,
  } = props;

  return (
    <MUIClickAwayListener
      disableReactTree={disableReactTree}
      mouseEvent={mouseEvent}
      onClickAway={onClickAway}
      touchEvent={touchEvent}
    >
      {children}
    </MUIClickAwayListener>
  );
};

ClickAwayListener.displayName = 'ClickAwayListener';

export default ClickAwayListener;
